import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const FULL_WIDTH_PATHS = ['/', '/pro'];

interface LayoutProps {
  showFooter?: boolean;
  noContainer?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  showFooter = true,
  noContainer = false
}) => {
  const location = useLocation();
  const isFullWidth = noContainer || FULL_WIDTH_PATHS.includes(location.pathname);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />

      <main id="main-content" className="flex-1">
        {isFullWidth ? (
          <div key={location.pathname}>
            <Outlet />
          </div>
        ) : (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" key={location.pathname}>
            <Outlet />
          </div>
        )}
      </main>

      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;